import produce from 'immer';
import React, { FC, useState } from 'react'
import { Button, Col, Container, Form, Modal, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'react-tippy';
import { startEditForm, startLoadForm, startRemoveForm } from '../../../actions/formListAction';
import { Form as FormModal } from '../../../models/formModel'
import { AppState } from '../../../reducers/rootReducer';
import "../elementpanel.scss"

export interface FormComponentProps {
    form: FormModal;
    groupList: any;
}

const FormComponent: FC<FormComponentProps> = ({ form, groupList }) => {
    const dispatch = useDispatch();
    const sessionState = useSelector((state: AppState) => state.session);
    const [open, setOpen] = useState(false);
    const [selectedGroupId, setSelectedGroupId] = useState(form.groupId);

    const onMove = () => {
        const newForm = produce(form, draft => { draft.groupId = selectedGroupId })
        dispatch(startEditForm(newForm));
        setOpen(false);
    }
    return (
        <>
            <div
                className="form-item theam-font"
                onClick={(e) => {
                    e.stopPropagation();
                    dispatch(startLoadForm(form));
                }}
            >
                <span
                    className={`form-name ${sessionState.selectedFormId === form.id
                        ? "form-active"
                        : ""
                        }`}
                >
                    {form.name}
                </span>
                <Tooltip title="Remove">
                    <button
                        className="form-remove mr-1 theam-dark-btn btn-dark"
                        onClick={(e) => {
                            e.stopPropagation();
                            dispatch(startRemoveForm(form.id));
                        }}
                    >
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                </Tooltip>

                {form.saveAs != 'template' && (
                    <Tooltip title="Add To Group">
                        <button
                            className="form-remove theam-dark-btn btn-dark"
                            onClick={(e) => {
                                e.stopPropagation();
                                setOpen(true);
                            }}
                        >
                            <i className="fa fa-arrow-circle-right" aria-hidden="true"></i>
                        </button>
                    </Tooltip>
                )}
            </div>
            {open && (
                <Modal
                    size={'lg'}
                    isOpen={open}
                    show={open}
                    onHide={() => {
                        setOpen(false)
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Move Form</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Container>
                            <Form.Row className="text-right">
                                <Col sm={12}>
                                    <Form.Group as={Row} controlId="firstName">
                                        <Form.Label column sm={4}>Select Group</Form.Label>
                                        <Col sm={8}>
                                            <Form.Control className='custom-select' as="select"
                                                value={selectedGroupId}
                                                onChange={(e) => {
                                                    setSelectedGroupId(e.target.value);
                                                }}>
                                                <option value="">Default Group</option>
                                                {groupList.map((group: any, index: number) => {
                                                    return <option key={`group-${group.id}`}
                                                        value={group.id}>
                                                        {group.name}</option>;
                                                })};
                                            </Form.Control>
                                        </Col>
                                    </Form.Group>
                                </Col>
                                <Col sm={12}>
                                    <Button variant="primary" type="btn" onClick={onMove}>
                                        Move
                                    </Button>
                                </Col>
                            </Form.Row>
                        </Container>
                    </Modal.Body>
                </Modal>
            )}
        </>
    )
}

export default FormComponent
